import {css} from '@emotion/css';
import {TreeNodeProps} from '@ennabl/rc-tree';

import ArrowDownIcon from 'components/icons/arrowDown.svg';
import ArrowRightIcon from 'components/icons/arrowRight.svg';
import DescendantIcon from 'components/icons/descendant.svg';

const sArrow = css`
  width: 16px;
`;

export const TreeSwitcherIcon = (nodeProps: TreeNodeProps) => {
  const {data, expanded} = nodeProps;

  if (!data?.children?.length) {
    return null;
  }

  if (expanded) {
    return <ArrowDownIcon data-testid='tree-switcher-expanded' className={sArrow} />;
  }

  return <ArrowRightIcon data-testid='tree-switcher-default' className={sArrow} />;
};

export const SearchSwitcherIcon = (nodeProps: TreeNodeProps) => {
  const {data, expanded} = nodeProps;

  if (!data?.children?.length) {
    return null;
  }

  if (expanded) {
    return <DescendantIcon />;
  }

  return <ArrowDownIcon />;
};
